import React from 'react';

import {
  Link
} from 'react-router-dom';

import PropTypes from 'prop-types';

import {
  tagBreadCrumbClick
} from 'src/Tagging/SalesTagging';

import {
  getEnv
} from 'src/Utility/utility';

import './GridBreadcrumbs.css';

const getBreadcrumbPathList = (currentPath) => {

  const breadCrumbs = [];

  breadCrumbs.push({ path: '/cloud/fibre/sales/leads', title: 'Fibre' });

  if (currentPath === '') {

    return breadCrumbs;
  }

  if( currentPath === 'CHOOSEPLAN'){
    breadCrumbs.push({ path: '/cloud/fibre/sales/order', title: 'Available fibre plans' });
  }

  return breadCrumbs;
};

const GridBreadcrumbs = ({ currentPath, isFibreAvailable }) => {

  const breadCrumbs = getBreadcrumbPathList(currentPath);

  const homeClickHandler = () => {
    tagBreadCrumbClick('Home', `https://www${ getEnv() }.vodacom.co.za/`, isFibreAvailable);
    window.location.href = '/';
  };

  const breadcrumbClickHandler = (title, path) => {
    const fullUrl = `https://www${ getEnv() }.vodacom.co.za${ path }`;
    tagBreadCrumbClick(title, fullUrl, isFibreAvailable);
  };

  return (
    <div className="breadcrumb-container">
      <ul className="breadcrumb-breadcrumb-list">
        <li className="breadcrumb-path">
          <span style={{ cursor: 'pointer' }} onClick={homeClickHandler}>Home</span>
        </li>

        {
          breadCrumbs.map(item =>
            <li key={item.path}>
              <Link
                className="breadcrumb-path"
                to={item.path}
                onClick={() =>breadcrumbClickHandler(item.title, item.path) }>
                {item.title}

              </Link>
            </li>
          )
        }
      </ul>
    </div>
  );
};

GridBreadcrumbs.propTypes = {
  currentPath: PropTypes.string,
  isFibreAvailable: PropTypes.bool
};

export default GridBreadcrumbs;
